const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/teams/list/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { compactPicklistFilterSchema } from '@/lib/zod-schemas/common/compactFilterSchemas';
const loopTeamsListSearchSchema = z.object({
  roleId: compactPicklistFilterSchema
});
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/teams/list/')({
  validateSearch: zodValidator(loopTeamsListSearchSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});